import { matchRange } from "./hub-ranking";

/** A row title with the matched text in bold (spec §4: “Matched text in the title is bold”). */
export function HighlightedTitle({
  text,
  query,
}: {
  text: string;
  query: string;
}) {
  const range = matchRange(text, query);
  if (!range) return <>{text}</>;
  return (
    <>
      {text.slice(0, range[0])}
      <b className="font-bold">{text.slice(range[0], range[1])}</b>
      {text.slice(range[1])}
    </>
  );
}
